<!-- eslint-disable vue/no-v-html -->
<template>
  <div
    v-html="sanitizedHtml"
    v-bind="$attrs"
  />
</template>

<script setup>
import { sanitizeRichHtml } from '@/shared/utils/sanitizeRichHtml';

defineOptions({ inheritAttrs: false });

const props = defineProps({
  html: {
    type: String,
    default: null,
  },
});

const sanitizedHtml = computed(() => sanitizeRichHtml(props.html));
</script>
